module.exports = __webpack_public_path__ + "img/user-persona.684c9487.png";